import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  toggle(event) {
    if (event.target.closest("[data-collapsible-ignore]")) return
    this.element.classList.toggle("open")
  }
}
